import { LANES, LANE_WIDTH } from '@accra/shared';

/** Lane 0 is the left (median side), lane 2 is the kerb lane. */
export function laneX(lane: number): number {
  return (lane - (LANES - 1) / 2) * LANE_WIDTH;
}

export function clampLane(lane: number): number {
  return Math.max(0, Math.min(LANES - 1, lane));
}

/** True once the bus has finished moving into its lane. */
export function isSettledIn(x: number, lane: number, tolerance = 0.6): boolean {
  return Math.abs(x - laneX(lane)) < tolerance;
}
